import { createStore } from 'vuex';
import createEquipmentModule from './modules/equipments';
import createAccountModule from './modules/accounts';
import createProfileModule from './modules/profile';
import createLayoutModule from './modules/layout';

let store = createStore({
    modules: {
        profile: createProfileModule(),
        equipments: createEquipmentModule(),
        accounts: createAccountModule(),
        layout: createLayoutModule(),
    }
});
export default store;